import React, { useCallback, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField';
import { AdditionalLayout } from '../Layout';
import { DisableEnableControls, loadLookupFromStaticDataSource, SetControlValue } from '../../../../../common/Utils';

function AdditionalTab(props) {
    var currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    // Same disposed-widget guard as PrimaryTab: the Utils helpers skip a ref whose instance() is gone.
    const loadLookupClient = useCallback((name, dataSource, valueExpr = 'id', displayExpr = 'text') => {
        loadLookupFromStaticDataSource(name, dataSource, props.formFields, props.formRefs, valueExpr, displayExpr);
    }, [props.formRefs, props.formFields]);

    const setFieldDisabled = useCallback((name, disabled) => {
        DisableEnableControls(name, disabled, props.formRefs);
    }, [props.formRefs]);

    const applyItemClassRule = useCallback((scheduleType) => {
        const isItemSchedule = scheduleType === 'I';
        setFieldDisabled('LOTSTORAGEENDDATE', !isItemSchedule);
        setFieldDisabled('SUBLOTSTORAGEENDDATE', !isItemSchedule);

        if (!isItemSchedule) {
            SetControlValue('LOTSTORAGEENDDATE', '', props.formRefs);
            SetControlValue('SUBLOTSTORAGEENDDATE', '', props.formRefs);
            props.setformFields(prev => ({
                ...prev,
                LOTSTORAGEENDDATE: '',
                SUBLOTSTORAGEENDDATE: ''
            }));
        }
    }, [props.formRefs, props.setformFields, setFieldDisabled]);

    const finalLayout = useMemo(() => {
        return AdditionalLayout;
    }, []);

    const scheduleApplyOptions = [
        { id: 'A', text: 'Automatically create all charges from rate schedule' },
        { id: 'M', text: 'Display charges from rate schedule and allow user to choose charges to be applied' },
        { id: 'U', text: 'Automatically apply Always Use usage types only' }
    ];

    const statusOptions = [
        { id: 'A', text: 'Active' },
        { id: 'I', text: 'Inactive' }
    ];

    const lotOptions = [
        { id: 'Y', text: 'Yes' },
        { id: 'N', text: 'No' }
    ];

    const sublotOptions = [
        { id: 'Y', text: 'Yes' },
        { id: 'N', text: 'No' }
    ];

    const recurringStorageOptions = [
        { id: 'Y', text: 'Yes, Always Generate Recurring Storage Charges' },
        { id: 'I', text: 'Yes, Always Generate Recurring Storage by Item Class/SubClass' },
        { id: 'L', text: 'Yes, Always Generate Recurring Storage by Lot Class/SubClass' },
        { id: 'E', text: 'Yes, Always Generate Recurring Using Location Exclusion List' },
        { id: 'N', text: 'No, Never Generate Recurring Storage Charges' }
    ];

    const handleAdditionalFormLoad = useCallback(() => {
        setTimeout(() => {
            loadLookupClient("SCHEDULEAPPLY", scheduleApplyOptions);
            loadLookupClient("STATUS", statusOptions);
            loadLookupClient("LOTSTORAGEENDDATE", lotOptions);
            loadLookupClient("SUBLOTSTORAGEENDDATE", sublotOptions);
            loadLookupClient("RECURRINGSTORAGE", recurringStorageOptions);
            applyItemClassRule(props.formFields?.SCHEDULETYPE);
        }, 100);
    }, [loadLookupClient, applyItemClassRule, props.formFields?.SCHEDULETYPE]);

    useEffect(() => {
        loadLookupClient("SCHEDULEAPPLY", scheduleApplyOptions);
        loadLookupClient("STATUS", statusOptions);
        loadLookupClient("LOTSTORAGEENDDATE", lotOptions);
        loadLookupClient("SUBLOTSTORAGEENDDATE", sublotOptions);
        loadLookupClient("RECURRINGSTORAGE", recurringStorageOptions);
    }, [loadLookupClient, props.formFields?.SCHEDULEAPPLY, props.formFields?.STATUS, props.formFields?.LOTSTORAGEENDDATE, props.formFields?.SUBLOTSTORAGEENDDATE, props.formFields?.RECURRINGSTORAGE]);

    // Apply the item class rule whenever SCHEDULETYPE changes
    useEffect(() => {
        applyItemClassRule(props.formFields?.SCHEDULETYPE);
    }, [props.formFields?.SCHEDULETYPE, applyItemClassRule]);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId='14E6CC50-9961-4163-A865-FCBC469914E5'
                layoutName='WMRateScheduleCodeAdditionalForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleAdditionalFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(AdditionalTab);

